'use client';
import { useEffect, type ReactNode } from 'react';
import { I18nProviderClient } from '@locales/client';
import { UserProvider } from '@/shared/providers/user-provider/user-provider';
import { NotificationsProvider } from '@/shared/providers/notifications-provider';
import { BreakpointsProvider } from '@/shared/providers/breakpoints-provider';
import { ToastProvider } from '@/shared/providers/toast-provider/ToastProvider';
import { SwrProvider } from '@/shared/providers/swr-provider/SwrProvider';
import { AppProgressBar as ProgressBar } from 'next-nprogress-bar';

type ProviderProps = {
  locale: string;
  children: ReactNode;
};

function Providers({ locale, children }: ProviderProps) {
  useEffect(() => {
    window.__lc = window.__lc || {};
    window.__lc.license = 14785209;
    window.__lc.integration_name = 'manual_channels';
    window.__lc.product_name = 'livechat';

    (function (n, t, c) {
      function i(n) {
        return e._h ? e._h.apply(null, n) : e._q.push(n);
      }
      var e = {
        _q: [],
        _h: null,
        _v: '2.0',
        on: function () {
          i(['on', c.call(arguments)]);
        },
        once: function () {
          i(['once', c.call(arguments)]);
        },
        off: function () {
          i(['off', c.call(arguments)]);
        },
        get: function () {
          if (!e._h)
            throw new Error(
              "[LiveChatWidget] You can't use getters before load."
            );
          return i(['get', c.call(arguments)]);
        },
        call: function () {
          i(['call', c.call(arguments)]);
        },
        init: function () {
          var n = t.createElement('script');
          n.async = true;
          n.type = 'text/javascript';
          n.src = 'https://cdn.livechatinc.com/tracking.js';
          t.head.appendChild(n);
        },
      };
      !n.__lc.asyncInit && e.init();
      n.LiveChatWidget = n.LiveChatWidget || e;
    })(window, document, [].slice);

    // Clarity.init('pt61f5peh8');
  }, []);

  return (
    <>
      <I18nProviderClient locale={locale}>
        <ToastProvider>
          <SwrProvider>
            <UserProvider>
              <NotificationsProvider>
                <BreakpointsProvider>
                  {children}
                  <ProgressBar
                    height="4px"
                    color="#131315"
                    options={{ showSpinner: false }}
                    shallowRouting
                  />
                </BreakpointsProvider>
              </NotificationsProvider>
            </UserProvider>
          </SwrProvider>
        </ToastProvider>
      </I18nProviderClient>

      <noscript>
        <a href="https://www.livechat.com/chat-with/14785209/" rel="nofollow">
          Chat with us
        </a>
        , powered by{' '}
        <a
          href="https://www.livechat.com/?welcome"
          rel="noopener nofollow"
          target="_blank"
        >
          LiveChat
        </a>
      </noscript>
    </>
  );
}

export { Providers };
